import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Col, Drawer, Form, Radio, Row, Spin } from "antd";
import PropTypes from "prop-types";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";

const Component = ({
	data = {},
	onUpdate,
	options: { subscriptions = [] },
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loading, visible } = state;
	const { slug, title } = data;
	const { hash, pathname, search } = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const handleClose = () => {
		navigate(-1);
	};

	const handleSubmit = () => {
		form.validateFields().then(({ subscription }) => {
			API.job
				.subscribe(slug, subscription)
				.then(() => {
					onUpdate(null, true);
					handleClose();
				})
				.catch(() => {});
		});
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.ATTACH}`: {
				if (slug) {
					setState((prevState) => ({ ...prevState, visible: true }));
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState((prevState) => ({ ...prevState, visible: false }));

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	const footer = (
		<>
			<Button
				type="primary"
				onClick={handleSubmit}
			>
				{Resources.confirm}
			</Button>
			<Button onClick={() => handleClose()}>{Resources.cancel}</Button>
		</>
	);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={footer}
			onClose={() => handleClose()}
			title={`${Resources.attach} ${Resources.subscription} ${title}`}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form
				layout="vertical"
				form={form}
			>
				{loading ? (
					<Spin className="sp-drawer-spin" />
				) : (
					<Form.Item
						name="subscription"
						required
					>
						<Radio.Group>
							<Row gutter={[16, 8]}>
								{subscriptions.map(({ label, value }) => (
									<Col
										xs={24}
										key={value}
									>
										<Radio value={value}>{label}</Radio>
									</Col>
								))}
							</Row>
						</Radio.Group>
					</Form.Item>
				)}
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
